import React from 'react';
import PropTypes from 'prop-types';
import NavDropdown from 'components/Nav/NavDropdown/NavDropdown';
import classes from './NavE.module.scss';

const NavE = (props) => {
  const {
    header, subHeader, searchPlaceholderText, nodes, image,
  } = props;

  const divImage = {
    backgroundImage: `url(${image.imageUrl})`,
  };

  return (
    <div className={classes.container}>
      <div className={classes.imgContainer} style={divImage} />
      <div className={classes.overlay}>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            {header && <div
              className={classes.title}
              dangerouslySetInnerHTML={{ __html: header }}
            />}
            {subHeader && <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: subHeader }}
            />}
            <div className={classes.dropdownWrapper}>
              <NavDropdown
                searchPlaceholderText={searchPlaceholderText}
                nodes={nodes}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NavE.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  subHeader: PropTypes.string,
  /**
   * Text that displays on the input element of the dropdown
  */
  searchPlaceholderText: PropTypes.string,
  /**
   * An image that displays as the background of the component
  */
  image: PropTypes.shape({
    id: PropTypes.string,
    providerName: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
  /**
   * A list of links that display directly below the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
  })),
};

export default NavE;
